export interface AddressStepTexts {
  title: string
  subtitle: string
  labels: {
    street: string
    buildingNumber: string
    interiorNumber: string
    colony: string
    city: string
    state: string
    postalCode: string
  }
  suggestions: {
    loading: string
  }
}

export interface AppDownloadStepTexts {
  title: string
  subtitle: string
}

export interface CurpEntryStepTexts {
  title: string
  subtitle: string
  infoText: string
  label: string
  helpText: string
}

export interface OccupationIncomeStepTexts {
  title: string
  subtitle: string
  labels: {
    occupation: string
    income: string
  }
}

export interface PersonalInfoStepTexts {
  title: string
  subtitle: string
  labels: {
    firstName: string
    paternalLastName: string
    maternalLastName: string
    dateOfBirth: string
    gender: string
    stateOfBirth: string
  }
  options: {
    male: string
    female: string
  }
}

export interface PhoneEmailStepTexts {
  phoneEmail: {
    title: string
    subtitle: string
    buttonText: string
    footerText: string
  }
  labels: {
    mobilePhone: string
    email: string
  }
}

export interface PinSetupStepTexts {
  title: string
  subtitle: string
  infoText: string
  labels: {
    pin: string
    confirmPin: string
  }
  errorMessage: string
  buttonText: string
  helpText: string
}

export interface VerificationCodeStepTexts {
  title: string
  subtitle: string
  buttonText: string
  footerText: string
  verificationCodeLabel: string
}

export const ADDRESS_STEP_TEXTS: AddressStepTexts = {
  title: "Domicilio",
  subtitle: "Esta es la dirección que aparece en tu INE. Si deseas enviar tu pedido a otra dirección podrás cambiarla más adelante.",
  labels: {
    street: "Calle*",
    buildingNumber: "Número exterior*",
    interiorNumber: "Interior",
    colony: "Colonia*",
    city: "Ciudad*",
    state: "Estado*",
    postalCode: "Código postal*",
  },
  suggestions: {
    loading: "Cargando sugerencias...",
  },
}

export const APP_DOWNLOAD_STEP_TEXTS: AppDownloadStepTexts = {
  title: "Completa tu compra desde la app Nelo",
  subtitle: "Parece que ya tienes una cuenta en Nelo o comenzaste a crear una. Completa tu compra desde la app.",
}

export const CURP_ENTRY_STEP_TEXTS: CurpEntryStepTexts = {
  title: "Ingresa tu CURP",
  subtitle: "Encuentra tu CURP en tu identificación oficial INE/IFE.",
  infoText:
    "Tu CURP ha sido generado automáticamente con la información proporcionada. Por favor verifica que sea correcto o edítalo si es necesario.",
  label: "CURP",
  helpText: "Si no la conoces, puedes consultarla en la página de CURP de la Secretaría de Gobernación",
}

export const OCCUPATION_INCOME_STEP_TEXTS: OccupationIncomeStepTexts = {
  title: "Ocupación e ingresos mensuales",
  subtitle: "Completa los siguientes campos con tu ocupación y tus ingresos mensuales después de impuestos",
  labels: {
    occupation: "Seleccionar ocupación",
    income: "Ingresos mensuales",
  },
}

export const PERSONAL_INFO_STEP_TEXTS: PersonalInfoStepTexts = {
  title: "Cuéntanos un poco sobre ti",
  subtitle: "Todos tus datos deben coincidir con tus documentos oficiales.",
  labels: {
    firstName: "Nombre (s)",
    paternalLastName: "Apellido paterno",
    maternalLastName: "Apellido materno",
    dateOfBirth: "Fecha de nacimiento",
    gender: "Género",
    stateOfBirth: "Lugar de nacimiento",
  },
  options: {
    male: "Masculino",
    female: "Femenino",
  },
}

export const PHONE_EMAIL_STEP_TEXTS: PhoneEmailStepTexts = {
  phoneEmail: {
    title: "Para comenzar, crea tu cuenta Nelo",
    subtitle:
      "Muy pronto podrás comprar a quincenas sin intereses en Tienda Nelo. Completa los siguientes pasos cuidando que tu información coincida con tus documentos oficiales.",
    buttonText: "Continuar y solicitar",
    footerText:
      "Para evaluar el riesgo crediticio, Nelo obtendrá tu historial crediticio del Círculo de Crédito. Al continuar, autorizas que Nelo obtenga la información crediticia y que esta pueda ser revisada nuevamente en un futuro mientras tengas una cuenta Nelo. Toda tu información es confidencial. Consulta nuestros términos y condiciones en www.nelo.mx",
  },
  labels: {
    mobilePhone: "Teléfono móvil",
    email: "Correo electrónico",
  },
}

export const PIN_SETUP_STEP_TEXTS: PinSetupStepTexts = {
  title: "Crea un NIP de verificación",
  subtitle: "Usarás este NIP para ingresar a tu cuenta Nelo al descargar la aplicación móvil.",
  infoText: "Crea un NIP de 4 dígitos para acceder a tu cuenta Nelo. Mantenlo seguro, recuérdalo y no lo compartas con nadie.",
  labels: {
    pin: "NIP de 4 dígitos",
    confirmPin: "Confirmar NIP",
  },
  errorMessage: "Tu NIP no coincide.",
  buttonText: "Continuar",
  helpText:
    "Necesitarás este NIP para ingresar a la app Nelo una vez que la descargues. Por seguridad, no compartas este número con nadie.",
}

export const VERIFICATION_CODE_STEP_TEXTS: VerificationCodeStepTexts = {
  title: "Ingresa el código de verificación",
  subtitle: "Escribe el código de 5 dígitos que enviamos a tu teléfono móvil vía WhatsApp.",
  buttonText: "Verificar",
  footerText: "",
  verificationCodeLabel: "Código de verificación",
}
